// extracted by mini-css-extract-plugin
module.exports = {"container":"NewSimpleLayout_container__Vs7iP","simpleLayout":"NewSimpleLayout_simpleLayout__78_jL"};